// test2010
(2010 && 0);
